import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Droplet, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

export default function PageShell({ title, overline, intro, children, testid }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid={testid}>
      <header className="border-b border-slate-200 bg-white sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="page-shell-logo">
            <span className="w-7 h-7 bg-slate-950 text-white flex items-center justify-center rounded-sm">
              <Droplet className="w-4 h-4" strokeWidth={2.2} />
            </span>
            <span className="font-chivo font-extrabold tracking-tight text-lg">
              LAB<span className="text-slate-400">2O</span>
            </span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 font-plexmono text-[10px] tracking-[0.2em] uppercase text-slate-500 hover:text-slate-950 transition-colors"
            data-testid="page-shell-back-link"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Back to site
          </Link>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          {overline && (
            <p className="font-plexmono text-[10px] tracking-[0.25em] uppercase text-slate-400" data-testid={`${testid}-overline`}>
              {overline}
            </p>
          )}
          <h1 className="mt-3 font-chivo font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-950" data-testid={`${testid}-heading`}>
            {title}
          </h1>
          {intro && (
            <p className="mt-4 max-w-2xl text-slate-600 leading-relaxed" data-testid={`${testid}-intro`}>
              {intro}
            </p>
          )}
        </motion.div>
        {children}
      </main>

      <Footer />
    </div>
  );
}
